export type Lookups = {
  active: boolean;
  id: string;
  label: {
    en: string;
    fr: string;
  };
  description: {
    en: string;
    fr: string;
  };
  order: number;
  type: string;
  placeholderText?: {
    en: string;
    fr: string;
  };
  text?: string;
  todo?: TodosType;
};

export type TodosType = {
  offerMade12HoursAgo: TodosItemType;
  offerMade24HoursAgo: TodosItemType;
  offerMade36HoursAgo: TodosItemType;
  offerMade48HoursAgo: TodosItemType;

  bgCheckRequested24HoursAgo: TodosItemType;
  bgCheckRequested48HoursAgo: TodosItemType;
  bgCheckRequested72HoursAgo: TodosItemType;
  bgCheckFlaggedByCertnCandidates: TodosItemType;
  bgCheckNotProcessedByCertn24HoursAgoCandidates: TodosItemType;

  hireFormRequested24HoursAgo: TodosItemType;
  hireFormRequested48HoursAgo: TodosItemType;
  hireFormRequested72HoursAgo: TodosItemType;
  hireFormCompleted24HoursAgo: TodosItemType;
  hireFormHelpRequested: TodosItemType;
  hireFormInReview: TodosItemType;

  workbrightRequested24HoursAgo: TodosItemType;
  workbrightRequested36HoursAgo: TodosItemType;
  workbrightRequested48HoursAgo: TodosItemType;
  workbrightRequested60HoursAgo: TodosItemType;
  workbrightRequested72HoursAgo: TodosItemType;
  workbrightCompleted: TodosItemType;
  workbrightAccepted: TodosItemType;
  workbrightDeclined: TodosItemType;

  languageEvaluation: TodosItemType;
  responseToCandidate: TodosItemType;
  dialogflow: TodosItemType;
  upcomingInterviews: TodosItemType;
};

export type TodosItemType = {
  actionLabel: LanguageLabels;
  heading: LanguageLabels | InterviewHeading;
  details: LanguageLabels;
  actionButton?: LanguageLabels | InterviewActionButton;
  modalMessage?: LanguageLabels;
  general?: {
    actionLabel: LanguageLabels;
    heading: LanguageLabels;
    details: LanguageLabels;
    actionButton?: LanguageLabels;
    modalMessage?: LanguageLabels;
  };
};

export type InterviewActionButton = {
  joinInterview: LanguageLabels;
  candidateDetails: LanguageLabels;
};

export type InterviewHeading = {
  videoInterview: LanguageLabels;
  phoneInterview: LanguageLabels;
  inpersonInterview: LanguageLabels;
};

export type LanguageLabels = {
  en: string;
  fr: string;
};

export enum ToDoTitle {
  UPCOMING_INTERVIEWS = 'upcomingInterviews',
  HR_FORM_COMPLETED_24HOURS = 'hireFormCompleted24HoursAgo',
}
